import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-sponsor-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sponsor-banner.component.html',
  styleUrls: ['./sponsor-banner.component.less']
})
export class SponsorBannerComponent {
  @Input() data: any;

  ngOnInit() {
    console.log('SponsorBannerComponent initialized with data:', this.data);
  }
}
